export const filterTypes = {
    'ACCOUNT_NAME': 'accountNames',
    'CONTRACT_STATUS': 'contractStatuses',
    'COUNTRIES': 'countries'
}